import { call, fork, put, take } from 'redux-saga/effects';
import {Api} from '../api';
import {Location} from '../api/types';
import {fetchLocations} from '../action/locationsCommands';
import {locationsFetched} from '../action/locationsEvents';
import {enqueueErrorSnackbar} from '../action/snackbarCommands';
import {getI18n} from 'react-i18next';
import Logger from '../common/logger';

export const onFetchLocations = function*() {
    try {
        const locations: Location[] = yield call(Api.getLocations);

        yield put(locationsFetched({ locations }));
    } catch (e) {
        Logger('Saga').error(e);
        yield put(enqueueErrorSnackbar({ message: getI18n().t('snackbar.error.fetch_locations') }));
    }
};

export function* fetchLocationsFlow() {
    while (true) {
        yield take(fetchLocations.toString());

        yield fork(onFetchLocations);
    }
}
